import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';
import { AdminProjectImages } from './AdminProjectImages';
import { LayoutSelector } from './LayoutSelector';
import { CmsHomeGallerySkeleton } from './CmsSkeletons';

const monoFont = "'IBM Plex Mono', monospace";

function normalizeLayoutType(layout: string | null | undefined) {
  if (!layout) return 'A';
  if (layout === 'split-vertical') return 'A';
  if (layout === 'vertical-scroll') return 'B';
  if (layout === 'horizontal-scroll') return 'C';
  if (layout === 'split-horizontal') return 'D';
  return layout;
}

export function AdminHomeGallery() {
  const { session } = useAuth();
  const [settingsId, setSettingsId] = useState<string | null>(null);
  const [savedLayout, setSavedLayout] = useState('A');
  const [pendingLayout, setPendingLayout] = useState('A');
  const [loadingLayout, setLoadingLayout] = useState(true);

  const loadHomeLayout = async () => {
    if (!session) return;
    setLoadingLayout(true);
    const { data } = await supabase
      .from('site_settings')
      .select('id, home_layout_type')
      .eq('user_id', session.user.id)
      .limit(1)
      .maybeSingle();
    if (data) {
      const normalized = normalizeLayoutType((data as any).home_layout_type);
      setSettingsId((data as any).id);
      setSavedLayout(normalized);
      setPendingLayout(normalized);
    }
    setLoadingLayout(false);
  };

  useEffect(() => { loadHomeLayout(); }, [session]);

  const applyLayout = async () => {
    if (!settingsId) return;
    await supabase.from('site_settings').update({ home_layout_type: pendingLayout }).eq('id', settingsId);
    setSavedLayout(pendingLayout);
  };

  if (loadingLayout) {
    return <CmsHomeGallerySkeleton />;
  }

  return (
    <div>
      <h2 className="uppercase text-sm font-light tracking-wider mb-4" style={{ color: 'rgba(247,246,242,0.85)' }}>GALERIA HOME</h2>

      <LayoutSelector
        currentLayout={pendingLayout}
        onSelect={setPendingLayout}
        hasChange={pendingLayout !== savedLayout}
        onApply={applyLayout}
      />

      <AdminProjectImages mode="home" sectionSlug="home" />
    </div>
  );
}
